// src/components/operationCenter/widgets/PlaceholderWidget.tsx
// Placeholder widget for unimplemented widget types

import React from "react";
import { Construction } from "lucide-react";
import type { WidgetProps } from "@/types/dashboard";
import { WIDGET_REGISTRY } from "./index";

const PlaceholderWidget: React.FC<WidgetProps> = ({ widget }) => {
  const definition = WIDGET_REGISTRY[widget.type];
  const Icon = definition?.icon ?? Construction;

  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-4 bg-slate-800/20 rounded-lg border border-slate-700/30">
      <Icon className="w-8 h-8 text-slate-500 mb-3" />
      <div className="text-sm font-medium text-slate-400">{widget.title}</div>
      <div className="text-xs text-slate-500 mt-1">Coming soon</div>
      <div className="text-[10px] text-slate-600 mt-2 font-mono">
        {widget.type}
      </div>
    </div>
  );
};

export default PlaceholderWidget;

